import type * as React from "react";

/**
 * A page outside the app shell (404, the feedback page): the logo on top
 * and the content on a panel, centred on the v3.2 canvas. Text is centred
 * unless `align="start"`.
 */
export function StandaloneFrame({
  logo,
  children,
  align = "center",
}: {
  /** The header mark (e.g. <Logo size={28} />). */
  logo: React.ReactNode;
  children: React.ReactNode;
  align?: "center" | "start";
}): React.JSX.Element {
  return (
    <div className="flex min-h-dvh w-full flex-col bg-v3-canvas font-v3 text-v3-text">
      <header className="flex h-16 shrink-0 items-center justify-center pt-[env(safe-area-inset-top)]">
        {logo}
      </header>
      <main className="flex flex-1 items-center justify-center px-4 pb-14">
        <div
          className={`w-full max-w-md rounded-[18px] bg-v3-panel p-6 shadow-v3-hairline sm:p-8 ${align === "center" ? "text-center" : "text-left"}`}
        >
          {children}
        </div>
      </main>
    </div>
  );
}
